import { createClient } from '@wallyhealth/web-core'
import config from '../../config'

const client = createClient({ baseUrl: config.PROVIDER_KAPI_URL })

export const fetchAppointmentDetails = ({ encodedId }) => {
  return client.get(`/check-in/${encodedId}`)
    .then(response => response.data)
}

export const checkInForAppointment = ({ encodedId }) => {
  return client.post(`/check-in/${encodedId}`)
    .then(response => response.data)
}
